import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ArrowDownThinIconSvg from './icon-arrow-down-thin.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ArrowDownThinIconSvg {...validProps} />;
}
SvgComponent.iconName = 'arrowDownThinIcon';

/**
 * @deprecated This is a legacy icon
 */
export const ArrowDownThinIcon = svgIconWrapper(SvgComponent);
